import React from "react";
import { useTranslation } from "react-i18next";
import { ReactFlowProvider } from "reactflow";
import { MenuItem, Select } from "@mui/material";
import { Graph } from "./components";
import { CLASS_NAME } from "./constants/cssClassNames";
import { ITopicPair } from "../nlp/~store/models/TopicPair";
import useGraph from "./hooks/useGraphSelect";
import "./NLPDesigner.css";

export interface NLPDesignerProps {
    topicPairs?: ITopicPair[];
    onSetTriggerNameFilter: (triggerName: string) => void;
}

const NLPDesigner = ({
    topicPairs = [],
    onSetTriggerNameFilter,
}: NLPDesignerProps) => {
    const { t } = useTranslation();
    const { edges, nodes, treesNames, selectedPairId, selectTree } = useGraph({
        topicPairs,
    });

    return (
        <div className={CLASS_NAME.ROOT}>
            <div className={CLASS_NAME.ROOT_HEADER}>
                <Select
                    className={CLASS_NAME.ROOT_HEADER_SELECT}
                    MenuProps={{
                        className: CLASS_NAME.ROOT_HEADER_SELECT_ITEM,
                    }}
                    placeholder={t("chat.subject")}
                    value={selectedPairId ? `${selectedPairId}` : ""}
                    onChange={selectTree}
                >
                    {treesNames.map((name) => (
                        <MenuItem key={name.value} value={name.value}>
                            <b>[{name.subject}]</b>&nbsp;
                            {name.label}
                        </MenuItem>
                    ))}
                </Select>
            </div>
            <ReactFlowProvider>
                <Graph
                    initialNodes={nodes}
                    initialEdges={edges}
                    onSetTriggerNameFilter={onSetTriggerNameFilter}
                />
            </ReactFlowProvider>
        </div>
    );
};

export default NLPDesigner;
